import React from 'react';
import Hero from '../../contains/Hero/Hero';
import OfferBrands from '../../components/offer-components/OfferBrands';
import Offer from '../../contains/offer/Offer';
import HowItWork from '../../contains/howItWork/HowItWork';
import Experts from '../../contains/experts/Experts';
import Price from '../../contains/price/Price';
import Support from '../../contains/supportUkraine/Support';
import freelanceImage from '../../assets/img/hero-section-compressed.png';
import WhiteBlock from '../../components/hero-components/WhiteBlock';
import Calculator from '../../contains/calculator/Calculator';


function ExpertsMain({t,handlerSelectModal}) {
  const freelanceData = {
    capture:t("hero_capture"),
    text:t("hero_description"),
    img:freelanceImage,
    altImage:t("alt_og_main")
  }
  return (
    <>
      <Hero t={t} data={freelanceData} handlerSelectModal={handlerSelectModal} whiteBlock={<WhiteBlock t={t}/>}/>
      <OfferBrands/>
      <Offer t={t} handlerSelectModal={handlerSelectModal}/>
      <HowItWork t={t}/>
      <Calculator t={t}/>
      <Experts t={t} handlerSelectModal={handlerSelectModal}/>
      <Price t={t} handlerSelectModal={handlerSelectModal}/>
      <Support t={t}/>
    </>
  );
}

export default ExpertsMain;